// src/components/store/sections/gallery/GalleryV55HexagoncombEmeraldMint.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV55HexagoncombEmeraldMint(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={55}
      archKey="hexagon_comb"
      archLabel="Hexagon Honeycomb Frames"
      palName="EmeraldMint"
      grad="from-emerald-500 via-teal-500 to-emerald-700"
      lightBg="bg-emerald-50"
      textCol="text-emerald-700"
      borderCol="border-emerald-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#10b981"
      {...props}
    />
  );
}
